module.exports = __webpack_public_path__ + "static/img/Registrobr2.d520a5c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/faq/Registrobr2.png
// module id = 1769
// module chunks = 5